import React, { useEffect, createElement } from 'react';
import { LandingPage } from './pages/LandingPage';
export function App() {
  useEffect(() => {
    // Defer Meta Pixel — load after page is interactive
    const loadPixel = () => {
      const f = window as any;
      if (f.fbq) return;
      const n: any = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(script);
      f.fbq('init', '1978672386112321');
      f.fbq('track', 'PageView');
      // noscript fallback
      const noscriptImg = document.createElement('img');
      noscriptImg.height = 1;
      noscriptImg.width = 1;
      noscriptImg.style.display = 'none';
      noscriptImg.src = 'https://www.facebook.com/tr?id=1978672386112321&ev=PageView&noscript=1';
      document.body.appendChild(noscriptImg);
    };
    // Use requestIdleCallback to load pixel when browser is idle
    if ('requestIdleCallback' in window) {
      ;
      (window as any).requestIdleCallback(loadPixel, {
        timeout: 5000
      });
    } else {
      setTimeout(loadPixel, 3000);
    }
  }, []);
  return <LandingPage data-id="element-0" />;
}